<mat-card>
  <mat-card-header>
    <mat-card-title>{{ webpage?.title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="content" [innerHTML]="webpage?.body"></div>
  </mat-card-content>
</mat-card>
